<div class="meal-plans">
  <div class="meal-plans__label">
    <strong>Opciones de comida</strong> para esta habitación:
  </div>
  <div class="meal-plans__badge-container">
    @for (badge of mealPlansBadges; track badge.label) {
      <div class="meal-plans__badge-container__badge">
        <mb-icon-text>
          <mb-icon icon="{{ badge.icon }}"></mb-icon>
          <span>{{ badge.label }}</span>
        </mb-icon-text>
      </div>
    }
  </div>
</div>
